/**
 * Landing feature — AR copy (Stitch rebuild, DEC-051).
 * Natural Modern Standard Arabic, logical order. Keys mirror landing.en.ts.
 */

export const landingAr = {
  // Header / footer
  'landing.nav.pathway': 'المنصة',
  'landing.nav.intelligence': 'الذكاء',
  'landing.nav.pricing': 'الأسعار',
  'landing.nav.login': 'تسجيل الدخول',
  'landing.nav.getStarted': 'ابدأ الآن',
  'landing.nav.menu': 'القائمة',
  'landing.scrollTop.label': 'العودة إلى الأعلى',
  'landing.footer.tagline':
    'طبقة الذكاء التي تحوّل العمل إلى حركة صاعدة — خاصة، ومترابطة، وثنائية اللغة.',
  'landing.footer.col.platform': 'المنصة',
  'landing.footer.platform.1': 'رسم الإشارات',
  'landing.footer.platform.2': 'مسارات النمو',
  'landing.footer.platform.3': 'ذكاء القوى العاملة',
  'landing.footer.col.company': 'الشركة',
  'landing.footer.company.1': 'الخصوصية',
  'landing.footer.company.2': 'تواصل معنا',
  'landing.footer.company.3': 'الشروط',
  'landing.footer.rights': 'جميع الحقوق محفوظة.',

  // Hero
  'landing.hero.badge': 'ذكاء مواهب مبني بالذكاء الاصطناعي',
  'landing.hero.lead': 'نُمكّن مليون',
  'landing.hero.word.1': 'موهبة',
  'landing.hero.word.2': 'محترف',
  'landing.hero.word.3': 'مستقبل',
  'landing.hero.tail': 'بحلول 2030. انطلاقًا من الأردن.',
  'landing.hero.signal.signals': 'إشارات',
  'landing.hero.signal.clarity': 'وضوح',
  'landing.hero.signal.growth': 'نمو',
  'landing.hero.subtitle':
    'يساعد Workerize.ai الأفراد على اكتشاف مهاراتهم والتحقق منها وتنميتها من خلال ذكاء مهني مدعوم بالذكاء الاصطناعي، ويربط المواهب بالفرص في الأردن والشرق الأوسط.',
  'landing.hero.ctaPrimary': 'ابدأ مجانًا',
  'landing.hero.ctaSecondary': 'استكشف المنصة',
  'landing.hero.mockup.score': 'الجاهزية المهنية',
  'landing.hero.mockup.skills': 'أبرز المهارات',
  'landing.hero.mockup.match': 'مطابقة المسار',
  'landing.hero.mockup.live': '+٣ أدوار جديدة',

  'landing.mockup.alt': 'معاينة لوحة منصة ذكاء المواهب من ووركرايز',

  // Pricing
  'landing.pricing.heading': 'نمو موجّه على أي نطاق',
  'landing.pricing.toggle.monthly': 'شهري',
  'landing.pricing.toggle.yearly': 'سنوي',
  'landing.pricing.toggle.preview': 'معاينة',
  'landing.pricing.note': 'تُعلَن الأسعار عند الإطلاق.',
  'landing.pricing.tier1.name': 'المستكشف',
  'landing.pricing.tier1.price': 'مجانًا',
  'landing.pricing.tier1.f1': 'خريطة إشارات مهارات شخصية',
  'landing.pricing.tier1.f2': 'مسار نمو واحد نشط',
  'landing.pricing.tier1.f3': 'رؤى المجتمع',
  'landing.pricing.tier1.cta': 'ابدأ الآن',
  'landing.pricing.tier2.name': 'النمو',
  'landing.pricing.tier2.price': 'قريبًا',
  'landing.pricing.tier2.badge': 'الأكثر شيوعًا',
  'landing.pricing.tier2.f1': 'خريطة إشارات علائقية كاملة',
  'landing.pricing.tier2.f2': 'مسارات نمو غير محدودة',
  'landing.pricing.tier2.f3': 'رؤى موجّهة استباقية',
  'landing.pricing.tier2.f4': 'دعم ذو أولوية',
  'landing.pricing.tier2.cta': 'انضمّ إلى الوصول المبكر',
  'landing.pricing.tier3.name': 'الفِرق',
  'landing.pricing.tier3.price': 'مخصّص',
  'landing.pricing.tier3.f1': 'ذكاء القوى العاملة',
  'landing.pricing.tier3.f2': 'الجاهزية على مستوى الفريق',
  'landing.pricing.tier3.f3': 'خرائط الحركة الداخلية',
  'landing.pricing.tier3.cta': 'مخصّص للفِرق',

  // FAQ
  'landing.faq.heading': 'الأسئلة الشائعة',
  'landing.faq.q1': 'لمن ووركرايز؟',
  'landing.faq.a1':
    'ووركرايز للمحترفين الذين يخوضون مسارات غير خطّية، ولفِرق المواهب التي تريد فهم الإمكانات داخل مؤسساتها وإطلاقها.',
  'landing.faq.q2': 'كيف يعمل التوجيه؟',
  'landing.faq.a2':
    'يُنمذِج ووركرايز العلاقات بين مهاراتك وأهدافك وإشارات السوق، ثم يقترح الخطوة التالية المنطقية بناءً على مسارك الفريد — لا على مطابقة الكلمات المفتاحية.',
  'landing.faq.q3': 'هل يمكن للأفراد استخدامه؟',
  'landing.faq.a3': 'نعم. خطّتا المستكشف والنمو مصمّمتان لإدارة المسار المهني الفردي.',
  'landing.faq.q4': 'هل يمكن للفِرق استخدامه؟',
  'landing.faq.a4':
    'نعم. تتيح خطة الفِرق للقادة رؤية خرائط الإشارات المجمّعة عبر المؤسسة لدعم الحركة الداخلية والاحتفاظ بالمواهب.',
  'landing.faq.q5': 'هل بياناتي خاصة؟',
  'landing.faq.a5':
    'ووركرايز مبنيّ على مبدأ الخصوصية أولًا. خرائط مهاراتك واستكشافاتك ملك لك وحدك، ولا نبيع البيانات الشخصية.',
  'landing.faq.q6': 'هل تدعمون العربية والإنجليزية؟',
  'landing.faq.a6':
    'نعم. ووركرايز ثنائي اللغة بالكامل ويدعم الكتابة من اليمين إلى اليسار، ومبنيّ لمواهب المنطقة والعالم.',

  // DARK composition
  'landing.dark.intel.lead': 'شبكة',
  'landing.dark.intel.accent': 'الإشارات المترابطة',
  'landing.dark.intel.body':
    'تجاوز الملفات الجامدة. يربط ووركرايز باستمرار نقاط البيانات من خبرتك المهنية ليُضيء أكثر مساراتك فاعلية.',
  'landing.dark.intel.card1.title': 'الرسم العلائقي',
  'landing.dark.intel.card1.body': 'شاهد كيف ترتبط كل مهارة بفرص السوق الأوسع.',
  'landing.dark.intel.card2.title': 'رؤى موجّهة',
  'landing.dark.intel.card2.body': 'احصل على توجيه استباقي مع تطوّر خريطة إشاراتك.',
  'landing.dark.node.skills': 'المهارات',
  'landing.dark.node.goals': 'الأهداف',
  'landing.dark.node.experience': 'الخبرة',
  'landing.dark.node.learning': 'التعلّم',
  'landing.dark.node.opportunities': 'الفرص',
  'landing.dark.node.insights': 'الرؤى',
  'landing.dark.features.heading': 'مبنيّ للمسارات الحديثة',
  'landing.dark.features.sub': 'ذكاء دقيق يتكيّف مع نموّك في الوقت الفعلي.',
  'landing.dark.feature1.title': 'رسم إشارات المهارات',
  'landing.dark.feature1.body':
    'حوّل الخبرة الخام إلى إشارات دقيقة تكشف ميزتك التنافسية الحقيقية.',
  'landing.dark.feature2.title': 'مسارات نمو مخصّصة',
  'landing.dark.feature2.body':
    'مخطّطات ملاحية تتكيّف مع اكتسابك للمهارات وتغيّر ظروف السوق.',
  'landing.dark.feature3.title': 'خاص بالتصميم',
  'landing.dark.feature3.body': 'يبقى استكشافك المهني ملكك حتى تقرّر مشاركته.',
  'landing.dark.feature4.title': 'سياق مهني ثنائي اللغة',
  'landing.dark.feature4.body':
    'العربية والإنجليزية من الدرجة الأولى مع سياق إقليمي عميق لأسواق المنطقة.',
  'landing.dark.feature5.title': 'رؤية مواهب الفريق',
  'landing.dark.feature5.body':
    'حدّد الكثافة والفجوات وفرص النمو الداخلي عبر مؤسستك.',
  'landing.dark.feature6.title': 'رؤى واعية بالسوق',
  'landing.dark.feature6.body':
    'ابقَ متقدّمًا على التغيّرات عبر تحليل الطلب على المهارات واتجاهات السوق.',
  'landing.dark.cta.heading': 'جاهز لرسم نموّك؟',
  'landing.dark.cta.button': 'ابدأ مجانًا',

  // LIGHT composition
  'landing.light.intel.lead': 'شبكة',
  'landing.light.intel.accent': 'إشارات الذكاء',
  'landing.light.intel.body':
    'يحلّل ووركرايز باستمرار الإشارات عبر حياتك المهنية ليرسم أكثر المسارات فاعلية.',
  'landing.light.intel.point1': 'رسم عقد المهارات في الوقت الفعلي',
  'landing.light.intel.point2': 'نمذجة المسارات التنبّؤية',
  'landing.light.intel.point3': 'التعرّف على الأنماط عبر الأدوار',
  'landing.light.node.skills': 'المهارات',
  'landing.light.node.experience': 'الخبرة',
  'landing.light.node.goals': 'الأهداف',
  'landing.light.showcase.step1.title': 'رسم إشارات المهارات',
  'landing.light.showcase.step1.body':
    'فكّك خبرتك إلى نقاط بيانات دقيقة للمطابقة الدقيقة.',
  'landing.light.showcase.step2.title': 'مسارات نمو مخصّصة',
  'landing.light.showcase.step2.body':
    'مخطّطات خطوة بخطوة مصمّمة حسب طموحك وقدرتك الحالية.',
  'landing.light.showcase.step3.title': 'رؤى موجّهة',
  'landing.light.showcase.step3.body':
    'توجيه في الوقت المناسب حين تتوافق فرص جديدة مع مسارك.',
  'landing.light.showcase.panel.label': 'الخطوة التالية المنطقية',
  'landing.light.showcase.panel.role': 'قائد مشروع · مركز الابتكار',
  'landing.light.showcase.panel.alignment': '78% توافق',
  'landing.light.showcase.panel.gaps': 'فجوتا مهارات',
  'landing.light.bento.heading': 'مصمّم للتطوّر',
  'landing.light.bento.sub':
    'منصّات المسار المهني التقليدية جامدة. ووركرايز ديناميكي وذكي ومبنيّ لتحوّلات عصر الذكاء الاصطناعي.',
  'landing.light.bento.card1.title': 'ذكاء غير خطّي',
  'landing.light.bento.card1.body':
    'المسارات أنظمة بيئية لا سلالم. يرسم ووركرايز كل تحوّل وخطوة جانبية وقفزة عبر المجالات.',
  'landing.light.bento.card1.tag1': 'تنبّؤي',
  'landing.light.bento.card1.tag2': 'علائقي',
  'landing.light.bento.card2.title': 'خصوصية انعدام الثقة',
  'landing.light.bento.card2.body':
    'بيانات مسارك ملك لك. استكشف المسارات دون إبلاغ جهات التوظيف حتى تكون جاهزًا.',
  'landing.light.bento.card3.title': 'نواة ثنائية اللغة',
  'landing.light.bento.card3.body':
    'مبنيّ من الأساس للمواهب عالية النمو بالعربية والإنجليزية معًا.',
  'landing.light.bento.card4.title': 'تحليل إشارات السوق',
  'landing.light.bento.card4.body':
    'نتابع التحوّلات الاقتصادية والطلب على المهارات لحظيًا لإبقاء مسار نموّك وثيق الصلة.',
  'landing.light.bento.card4.cta': 'اطّلع على المحرّك الحيّ',
} as const;

export type LandingAr = typeof landingAr;
